export default __webpack_public_path__ + "static/media/vertical-line.5749854f.svg";